import React from 'react';

import 'react-datepicker/dist/react-datepicker.css';
import RawGenericDatePicker from '../generic-date-picker/RawGenericDatePicker';

function RawDayPicker({...props}) {
    return <RawGenericDatePicker showTimeSelect={false} dateFormat={'dd MMM yyyy'} {...props} />;
}

export {RawDayPicker};
